// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback__toggle-btn {\n  width: auto;\n  min-width: 80px;\n  height: auto;\n  margin: 0 2px;\n  padding: 10px 20px;\n  font-size: 15px;\n}\n.feedback__toggle-btn--lg {\n  padding: 10px 60px;\n}\n@media (max-width: 1500px) {\n.feedback__toggle-btn--lg {\n    padding: 10px 20px;\n}\n}\n@media (max-width: 1025px) {\n.feedback__toggle-btn {\n    padding: 5px;\n    font-size: 14px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
